<div [hidden]="(filterText$ | async)?.length<1">
  <app-strip-list-header>
    <div class="col-6">
      {{ 'ml_144075' | translate}}
    </div>
    <div class="col-6">
      {{ 'ml_144076' | translate}}
    </div>
  </app-strip-list-header>
  <div [ngClass]="{'scrollBar': true}">
    @for(item of dataSource$ | async; track $index){
    <div (click)="itemSelected(item)">
      <app-strip-list-item>
        <div class="col-6">
          {{ item.apexId }}
        </div>
        <div class="col-6 text-ellipsis">
          {{ item.fullName }}
        </div>
      </app-strip-list-item>
    </div>
    }
    <app-loading-spinner [hidden]="!(processing$ | async)"></app-loading-spinner>
  </div>
</div>
